import { render } from "./WebSocketTest.vue?vue&type=template&id=61c7baec&scoped=true"
import script from "./WebSocketTest.vue?vue&type=script&lang=js"
export * from "./WebSocketTest.vue?vue&type=script&lang=js"

import "./WebSocketTest.vue?vue&type=style&index=0&id=61c7baec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c7baec"]])

export default __exports__